<template>
  <FaqList :items="items" />
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { PERSON_TYPES } from 'acces-impot-settings-report'
import { PRICES } from 'acces-impot-settings-price'
import { formatPrice } from '@/helpers/locale'
import FaqList from '@/components/Faq/FaqList.vue'

export default {
  name: 'FaqService',
  components: {
    FaqList,
  },

  computed: {
    ...mapState('page', ['country']),

    ...mapGetters({
      locale: 'page/locale',
    }),

    adultPrice() {
      return this.getPriceByCategory(PERSON_TYPES.self)
    },

    childPrice() {
      return this.getPriceByCategory(PERSON_TYPES.child)
    },

    items() {
      return [...Array(13)].map((_, index) => ({
        question: this.$t(`item${index + 1}.question`),
        answer: this.$t(`item${index + 1}.answer`, {
          adultPrice: this.adultPrice,
          childPrice: this.childPrice,
        }),
      }))
    },
  },

  methods: {
    getPriceByCategory(category) {
      return this.formatPrice(PRICES[this.country].report[category])
    },

    formatPrice(price) {
      // Remove the space before or after the currency symbol
      return formatPrice(price, this.locale, 0)
        .replace(/(.)\s(.)/g, (_, p1, p2) => {
          if ([p1, p2].some(p => /[^\d\w]/.test(p))) return p1 + p2
        })
        .trim()
    },
  },
}
</script>

<i18n src="@/locales/faq-service.json" />
